import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    width: '73px',
  },
  wrapper: {
    width: 48,
    height: 8,
    borderRadius: 10,
    background: theme.palette.secondary.light,
    marginLeft: 4,
  },
  line: {
    width: '50%',
    height: '100%',
    borderRadius: 10,
    background: theme.palette.success.main,
  },
}))
